export const ApiBasePath = window["ApiBasePath"] || {
  location: "/api/location",
  departments: "/",
  dealers: "/api/dealers",
  pricing: "/api/pricing",
  serviceDetails: "/api/servicedetails",
  assign: "/",
  dealersList: "/",
  offers: "/",
  takataRecall: "/",
  infomedia: "/api/infomedia",
  xtime: "/",
  form: "/",
  finance: "/proxy/api/financecalculator",
};
